export default class AssumedRiskOnTheContract {
    public Id: number;
    public Name: string;
    public Description: string;
    public constructor(id: number, name: string, desc: string) {
        this.Id = id;
        this.Name = name;
        this.Description = desc;
    }
}